import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './equipmentblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchEquipmentInfo } from '../../../services/api'; // Новая функция

const EquipmentBlock = () => {
    const { settings } = useAccessibility();
    const [equipmentData, setEquipmentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchEquipmentInfo();
                // Данные теперь в response.data[0].attributes
                setEquipmentData(response.data[0].attributes);
                console.log('Equipment data:', response.data[0].attributes);
            } catch (err) {
                console.error('Error fetching equipment data:', err);
                setError('Не удалось загрузить данные о материально-техническом обеспечении');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // File link component
    const FileLink = ({ file, label, fallbackUrl, fallbackExt }) => {
        if (file?.data?.attributes?.url) {
            return (
                <Link
                    href={`${file.data.attributes.url}`}
                    children={`${label} (${file.data.attributes.ext || 'PDF'})`}
                    color={linkColor}
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        if (fallbackUrl) {
            return (
                <Link
                    href={fallbackUrl}
                    children={`${label} (${fallbackExt})`}
                    color={linkColor}
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        return null;
    };

    if (loading) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ И ОСНАЩЕННОСТЬ ОБРАЗОВАТЕЛЬНОГО ПРОЦЕССА. ДОСТУПНАЯ СРЕДА'
            headerColor={textColor}
        >
            <div>Загрузка данных о материально-техническом обеспечении...</div>
        </Block>
    );

    if (error) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ И ОСНАЩЕННОСТЬ ОБРАЗОВАТЕЛЬНОГО ПРОЦЕССА. ДОСТУПНАЯ СРЕДА'
            headerColor={textColor}
        >
            <div>{error}</div>
        </Block>
    );

    if (!equipmentData) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ И ОСНАЩЕННОСТЬ ОБРАЗОВАТЕЛЬНОГО ПРОЦЕССА. ДОСТУПНАЯ СРЕДА'
            headerColor={textColor}
        >
            <div>Данные не найдены</div>
        </Block>
    );

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ И ОСНАЩЕННОСТЬ ОБРАЗОВАТЕЛЬНОГО ПРОЦЕССА. ДОСТУПНАЯ СРЕДА'
            headerColor={textColor}
            id='equipment'
            aria-label="Материально-техническое обеспечение и оснащенность образовательного процесса. Доступная среда"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* Материально-техническое обеспечение */}
                        <section aria-labelledby="material-header">
                            <h3 id="material-header" className={style.sectionHeader} style={{ color: textColor }}>
                                Материально-техническое обеспечение
                            </h3>
                            
                            <div className={style.row}>
                                <h4 id="requirements-header" className={style.header} style={{ color: textColor }}>Соответствие требованиям</h4>
                                <div className={style.text} style={{ color: textColor }} aria-labelledby="requirements-header">
                                    ГБУ ДО КК «СШОР «Самбо» соблюдены требования, установленные федеральными стандартами спортивной подготовки к материально-техническим условиям реализации этапов спортивной подготовки предусматривают (в том числе на основании договоров, заключенных в соответствии с гражданским законодательством Российской Федерации, существенным условием которых является право пользования соответствующей материально-технической базой и (или) объектом инфраструктуры)
                                </div>
                            </div>

                            <div className={style.row}>
                                <h4 id="facilities-header" className={style.header} style={{ color: textColor }}>Основные объекты</h4>
                                <div className={style.text} style={{ color: textColor }} aria-labelledby="facilities-header">
                                    <ul className={style.list}>
                                        {equipmentData.MainObjects?.map((item) => (
                                            <li key={item.id}>{item.Object}</li>
                                        ))}
                                        <li>
                                        наличие медицинского пункта, оборудованного в соответствии с приказом Минздрава России от 23.10.2020 N 1144н "Об утверждении порядка организации оказания медицинской помощи лицам, занимающимся физической культурой и спортом (в том числе при подготовке и проведении физкультурных мероприятий и спортивных мероприятий), включая порядок медицинского осмотра лиц, желающих пройти спортивную подготовку, заниматься физической культурой и спортом в организации и (или) выполнить нормативы испытаний (тестов) Всероссийского физкультурно-спортивного комплекса "Готов к труду и обороне" (ГТО)" и форм медицинских заключений о допуске к участию физкультурных и спортивных мероприятиях" (зарегистрирован Минюстом России 03.12.2020, регистрационный N 61238)
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className={style.row}>
                                <h4 id="support-header" className={style.header} style={{ color: textColor }}>Обеспечение обучающихся</h4>
                                <div className={style.text} style={{ color: textColor }} aria-labelledby="support-header">
                                    <ul className={style.list}>
                                        {equipmentData.Provision?.map((item) => (
                                            <li key={item.id}>{item.Provision}</li>
                                        ))}
                                        <li>
                                            <Link
                                                fontFamily='Roboto, sans-serif'
                                                fontSize='1rem'
                                                fontWeight='500'
                                                color={linkColor}
                                                href="https://drive.google.com/file/d/1ShqNy5R8Uk47xgU-5mr9gYWP8uR6T9j6/view"
                                                children='обеспечение оборудованием и спортивным инвентарем, необходимыми для прохождения спортивной подготовки, обеспечение спортивной экипировкой'
                                            />
                                        </li>
                                    </ul>
                                    <FileLink 
                                        file={equipmentData.EquipmentFile}
                                        label="Перечень оборудования и инвентаря"
                                        fallbackUrl="https://drive.google.com/file/d/1ShqNy5R8Uk47xgU-5mr9gYWP8uR6T9j6/view?usp=sharing"
                                        fallbackExt="PDF"
                                    />
                                </div>
                            </div>

                            <div className={style.row}>
                                <h4 id="centers-header" className={style.header} style={{ color: textColor }}>Центры единоборств</h4>
                                <div className={style.text} style={{ color: textColor }} aria-labelledby="centers-header">
                                    <p>В центрах единоборств оборудованы:</p>
                                    <ul className={style.list}>
                                        {equipmentData.Equipment?.map((item) => (
                                            <li key={item.id}>{item.Equipment}</li>
                                        ))}
                                        <li>
                                            <Link
                                                color={linkColor}
                                                fontFamily='Roboto, sans-serif'
                                                fontSize='1rem'
                                                fontWeight='500'
                                                href='https://drive.google.com/drive/folders/1r_6CrWGeq5JFl-4GzWmkP6aB6dBRSv5K'
                                                children='доступ к системам и информационно-телекоммуникационным сетям, электронным образовательным ресурсам'
                                            />
                                        </li>
                                    </ul>
                                    <FileLink 
                                        file={equipmentData.OnlineEducationFile}
                                        label="Электронные образовательные ресурсы"
                                        fallbackUrl="https://drive.google.com/drive/folders/1r_6CrWGeq5JFl-4GzWmkP6aB6dBRSv5K?usp=sharing"
                                        fallbackExt="Ссылка"
                                    />
                                </div>
                            </div>

                            <div className={style.row}>
                                <h4 id="hostel-header" className={style.header} style={{ color: textColor }}>Общежития</h4>
                                <div className={style.text} style={{ color: textColor }} aria-labelledby="hostel-header">
                                    <p>Жилые помещения в общежитии, интернате отсутствуют. Формирование платы за проживание в общежитии отсутствует.</p>
                                </div>
                            </div>
                        </section>

                        {/* Доступная среда */}
                        <section aria-labelledby="accessible-header">
                            <h3 id="accessible-header" className={style.sectionHeader} style={{ color: textColor }}>
                                Доступная среда
                            </h3>
                            
                            <div className={style.row}>
                                <h4 id="accessibility-header" className={style.header} style={{ color: textColor }}>Доступность центров</h4>
                                <div className={style.text} style={{ color: textColor }} aria-labelledby="accessibility-header">
                                    <p>Входы в центры единоборств оборудованы пандусами, которые обеспечивают доступ маломобильных групп населения, включая инвалидов и пожилых людей.</p>
                                </div>
                            </div>

                            <div className={style.row}>
                                <h4 id="special-needs-header" className={style.header} style={{ color: textColor }}>Специальные условия</h4>
                                <div className={style.text} style={{ color: textColor }} aria-labelledby="special-needs-header">
                                    <p>Специальные технические средства обучения коллективного и индивидуального пользования инвалидов и лиц с ограниченными возможностями здоровья отсутствуют, так как в учреждении не реализуются образовательные программы по адаптивным видам спорта.</p>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </FadeIn>
        </Block>
    )
}

export default EquipmentBlock;